import { Link } from "react-router-dom";
import {
  FooterContainer,
  FooterWrapper,
  SocialWrapper,
  FooterNavWrapper,
  CopyRightWrapper,
} from "../../styles/components/footer.style";

const Footer = () => {
  return (
    <FooterContainer>
      <FooterWrapper>
        <FooterNavWrapper>
          <div className="logo">
            <Link to="/">
              <img
                style={{ width: "90px" }}
                src="/images/RTGLOGO.svg"
                alt="Reliable Trucking Group logo"
              />
            </Link>
          </div>
          <div className="nav-links">
            <Link className="nav" to="/">
              Home
            </Link>
            <Link className="nav" to="/about">
              About us
            </Link>
            <Link className="nav" to="/">
              Contact us
            </Link>
            <Link className="nav" to="/about">
              Request a Quote
            </Link>
          </div>
        </FooterNavWrapper>
        <SocialWrapper>
          <a
            href="https://www.linkedin.com/company/reliable-trucking-group-rtg/"
            target="_blank"
            rel="noreferrer"
          >
            <img src="/images/linkedin.svg" alt="linkedin logo" />
          </a>
        </SocialWrapper>
      </FooterWrapper>
      <CopyRightWrapper>
        © Copyright 2024, Reliable Trucking Group. All Rights Reserved.
      </CopyRightWrapper>
    </FooterContainer>
  );
};

export default Footer;
